"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _Icon = require("../../media/icon/Icon");
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _globalTokens = require("../../../shared/global-tokens");
var _InnerButton = require("../../controls/buttons/InnerButton");
var _jsxRuntime = require("react/jsx-runtime");
var ChevronWrapper = (0, _styledComponents.default)(_InnerButton.NonVisualButton).withConfig({
  displayName: "ExpandChevron__ChevronWrapper",
  componentId: "sc-3vc4p5-0"
})(["cursor:pointer;padding:0 ", ";"], _globalTokens.globalSpacing['200']);
var ExpandChevron = function ExpandChevron(_ref) {
  var expanded = _ref.expanded;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(ChevronWrapper, {
    "aria-label": expanded ? 'Collapse row' : 'Expand row',
    "data-cy": expanded ? 'collapse-row' : 'expand-row',
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.Icon, {
      size: 'm',
      icon: expanded ? 'chevronLUp' : 'chevronLDown'
    })
  });
};
var _default = exports.default = ExpandChevron;